import { TypeOrmModule } from "@nestjs/typeorm";
import { Module } from "@nestjs/common";
import { MachineEntity } from "./entities/machine-entity";
import { MachinesController } from "./machines-controller";
import { MachinesService } from "./machines-service";
import { MachinesRepo } from "./repository/machines-repo";


@Module({

    imports:[TypeOrmModule.forFeature([MachineEntity])],
    controllers:[MachinesController],
    providers:[MachinesService,MachinesRepo]
})
export class MachinesModule{}